import React, { useEffect, useState, Fragment } from 'react';
import { Clock3Icon } from 'lucide-react';
type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};
function getNextMidnight(): number {
  const target = new Date();
  target.setHours(23, 59, 59, 999);
  return target.getTime();
}
function getTimeLeft(): TimeLeft {
  const target = getNextMidnight();
  const difference = Math.max(0, target - Date.now());
  return {
    hours: Math.floor(difference / 3600000),
    minutes: Math.floor(difference % 3600000 / 60000),
    seconds: Math.floor(difference % 60000 / 1000)
  };
}
function formatTime(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [time, setTime] = useState<TimeLeft>(getTimeLeft);
  useEffect(() => {
    const interval = window.setInterval(() => setTime(getTimeLeft()), 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <div className="mx-auto max-w-xl text-center" data-id="element-1">
      <div className="mb-4 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-rose-200" data-id="element-2">
        <Clock3Icon className="h-4 w-4" aria-hidden="true" data-id="element-3" />
        Precio de lanzamiento · cierra hoy
      </div>
      <div className="flex items-center justify-center gap-2 sm:gap-4" aria-live="polite" aria-label={`Quedan ${time.hours} horas, ${time.minutes} minutos y ${time.seconds} segundos`} data-id="element-4">
        {[[time.hours, 'HS'], [time.minutes, 'MIN'], [time.seconds, 'SEG']].map(([value, label]) => <Fragment key={String(label)} data-id="element-5">
            <div className="min-w-[76px] rounded-lg border border-rose-200/30 bg-[#240d1a] px-3 py-3 sm:min-w-[104px] sm:px-5" data-id="element-6">
              <span className="block font-serif text-3xl leading-none text-[#fff9f2] sm:text-5xl" data-id="element-7">
                {formatTime(Number(value))}
              </span>
              <span className="mt-2 block text-[10px] font-bold tracking-[0.16em] text-rose-200" data-id="element-8">
                {label}
              </span>
            </div>
            {label !== 'SEG' && <span className="pb-4 font-serif text-2xl text-[#d6a25d]" aria-hidden="true" data-id="element-9">
                :
              </span>}
          </Fragment>)}
      </div>
      <p className="mt-4 text-sm text-rose-100/80" data-id="element-10">
        Después sube USD 10. Esta condición no vuelve.
      </p>
    </div>;
}